import Notification from "rc-notification";
import 'rc-notification/assets/index.css';
import {mediaMatch} from "../utils";
import {useTranslation} from "react-i18next";

let notification;
let isMdmax = mediaMatch.isMdmax;

const wrapStyl = isMdmax ? {
  top: '45%',
  left: '50%',
  width: '50%',
  transform: 'translate(-50%,-50%)',
  boxShadow: 'none',
  backgroundColor: 'transparent',
} : {
  top: 50,
  left: '50%',
  width: 'auto',
  transform: 'translateX(-50%)',
};

Notification.newInstance(
  {
    style: wrapStyl,
    maxCount: 1,
  },
  n => {
    notification = n;
  },
);


const types = {
  info: {
    icon: 'icon-warning-circle',
    color: '#1890ff'
  },
  success: {
    icon: 'icon-check-circle',
    color: '#52c41a'
  },
  warn: {
    icon: 'icon-warning-circle',
    color: '#faad14'
  },
  error: {
    icon: 'icon-close-circle',
    color: '#f5222d'
  },
  loading: {
    icon: 'icon-loading-thin',
    color: '#eee'
  },
};

function NoticeWrap({ msg, type }) {
  const { t } = useTranslation();
  
  return (
    isMdmax
      ? <div className="items-center flex flex-col text-center">
        <i className={`iconfont ${types[type].icon} ${type === 'loading' ? 'loading-animate loading-animate-spin' : ''}`}
           style={{ color: '#eee', fontSize: type === 'loading' ? 42 : 50, marginBottom: 0 }}></i>
        <span className="text-[14px] text-white mt-[5px]">{t(msg)}</span>
      </div>
      : <div className="flex items-center">
        <i className={`iconfont ${types[type].icon}-fill`}
           style={{ color: types[type].color, marginRight: 12, fontSize: 22 }}></i>
        <span className="text-[15px]">{t(msg)}</span>
      </div>
  );
}

let loadingKey;

export default function useNotice() {
  isMdmax = mediaMatch.isMdmax;
  
  let styl = isMdmax ? {
    boxShadow: 'none',
    width: '72%',
    margin: '0 auto',
    padding: '10px 10px 20px',
    backgroundColor: 'rgba(0,0,0,.75)'
  } : {
    padding: '12px 28px',
    borderRadius: 5,
    boxShadow: '0 1px 15px #aaa'
  };
  
  return {
    info: (msg, duration = 3) => {
      notification.notice({
        duration,
        style: styl,
        content: (
          <NoticeWrap msg={msg} type="info"/>
        ),
      });
    },
    success: (msg, duration = 3) => {
      notification.notice({
        duration,
        style: styl,
        content: (
          <NoticeWrap msg={msg} type="success"/>
        ),
      });
    },
    warn: (msg, duration = 3) => {
      notification.notice({
        duration,
        style: styl,
        content: (
          <NoticeWrap msg={msg} type="warn"/>
        ),
      });
    },
    error: (msg, duration = 3) => {
      notification.notice({
        duration,
        style: styl,
        content: (
          <NoticeWrap msg={msg} type="error"/>
        ),
      });
    },
    loading: (msg, duration = 60) => {
      if (!isMdmax) return;
      loadingKey = Date.now();
      
      notification.notice({
        duration,
        style: styl,
        content: (
          <NoticeWrap msg={msg} type="loading"/>
        ),
        key: loadingKey,
      });
    },
    hide: () => {
      setTimeout(() => {
        notification.removeNotice(loadingKey);
      }, 100);
    }
  };
}

